import { Injectable } from "@angular/core";
import { BackendService } from "../backend/backend.service";
import { environment } from "../../../../environments/environment";
import { BehaviorSubject, Observable } from "rxjs";

interface getDigilockerConfigUrlInterface {
  url: string,
  message: string,
  status: number
}

interface aadhaarCallbackInterface {

  full_name: string,
  dob: Date,
  zip: string,
  profile_image: string,
  father_name: string,
  gender: 'M' | 'F',
  masked_aadhaar: string,
  mobile_number: string,
}

@Injectable({
  providedIn: "root",
})
export class AadhaarBasedAuthenticationService {

  private baseUrl = '/aadhar-based-authentication'
  private isAadhaarRequiredState = new BehaviorSubject<boolean>(false);
  
  constructor(private backendService: BackendService) {}

  getAadharBasedAuthentication() {
    console.log("hello, this is from getAadharbase authentication");
    return this.backendService.get(`${this.baseUrl}`);
  }

  getDigilockerConfigUrl(): Observable<getDigilockerConfigUrlInterface> {
     return this.backendService.get(`${this.baseUrl}/digilocker-url`) as Observable<getDigilockerConfigUrlInterface>
  }

  getAadhaarDetails() {
    return this.backendService.get(`${this.baseUrl}/aadhaar-details`);
  }

  loadAadhaarRequirement(){
    this.getAadharBasedAuthentication().subscribe((res: any) => {
      console.log("response from aadhaar service", res)
      console.log("res.aadhar", res. aadhar)
      this.isAadhaarRequiredState.next(res. aadhar)
    })
  }

  isAadhaarRequired(){
    return this.isAadhaarRequiredState.getValue()
  }
}
